<!doctype html>
<html lang="en">

<head>
    <meta charset="utf-8">
    <title>Thank you page</title>
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
        * {
            line-height: 1.2;
            margin: 0;
        }

        html {
            color: #888;
            display: table;
            font-family: sans-serif;
            height: 100%;
            text-align: center;
            width: 100%;
        }

        body {
            background: #e7e7e8 none repeat scroll 0 0;
            display: table-cell;
            margin: 2em auto;
        }

        h1 {
            color: #555;
            font-size: 2em;
            font-weight: 400;
            text-align: center;
        }

        p {
            margin: 0 auto;
            width: 280px;
        }

        .container-fluid {

            background: #ffffff none repeat scroll 0 0;
            height: 78px;
            position: relative;
            z-index: 5;
        }

        .text-container {
            margin: 10% auto;
        }

        .logo-image {

            width: auto;
            float: left;
            margin: 14px;
        }

        @media only screen and (max-width: 280px) {
            body,
            p {
                width: 95%;
            }
            h1 {
                font-size: 1.5em;
                margin: 0 0 0.3em;
            }
        }
    </style>
</head>

<body>
    <div class="text-container">
        <h1>Thank You</h1>
        <p>You have successfully submitted the survey.</p>
    </div>
</body>

</html>